module.exports = __webpack_public_path__ + "static/media/PCCLoginFocus.033e47d3.svg";